<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    华强北站<br>
站点介绍<br>
7号线华强北站位于华强北路与振中路相交处，西侧为华强电子世界及其地下室，东侧为广博现代之窗大厦、赛格经济大厦、赛格工业大厦、康乐电子有限公司、宝华大厦和赛格广场。华强北站装修以米白色及淡蓝色为主色调，柱面采用搪瓷钢板，现场美观大方，经济适用，以LED圆形造型灯具设计特色展示出"中国梦--缤纷生活梦"的总体文化特征。该站为地下站。（1、华强北站装修以米白色及淡蓝色为主色调，不是淡绿色；2、以LED圆形造型灯具设计特色，不是倒三角。）<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:07	23:47	2号线	2分35秒	5分45秒<br>
莲塘	06:14	23:52	2号线	2分35秒	5分45秒<br>
西丽湖	06:36	23:16	7号线	3分35秒	5分55秒<br>
太安	06:13	23:41	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:12	23:47	2号线	4分钟	5分钟<br>
莲塘	06:14	23:52	2号线	4分钟	5分钟<br>
西丽湖	06:35	23:16	7号线	4分钟	5分55秒<br>
太安	06:12	23:41	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:12	00:37	2号线	4分钟	5分钟<br>
莲塘	06:14	00:52	2号线	4分钟	5分钟<br>
西丽湖	06:36	00:16	7号线	4分钟	5分55秒<br>
太安	06:12	00:41	7号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
振华路南侧、周六福珠宝华强北旗舰店<br><br>
B出入口:<br>
华强北捐血站、深纺大厦、远望数码商城、茂业天地<br><br>
C出入口:<br>
深圳中心公园、中航北苑、中航城君尚购物中心<br><br>
D1出入口:<br>
华强北路东侧（南）、宝华大厦、振中路南侧、赛格广场、华强北地铁商业街、华强电子世界、深圳LED国际交易中心<br><br>
D2出入口:<br>
振中路南侧、赛格广场、京华大厦.、华强北地铁商业街、华强电子世界、深圳LED国际交易中心<br><br>
E1出入口:<br>
华强北路东侧（北）、振中路北侧、华强北步行街、现代之窗大厦、华联发大厦、华强健康电子智能家居国际交易中心、华强广场酒店、广发银行<br><br>
E2出入口:<br>
现代之窗大厦、华联发大厦、华强北地铁商业街、华强健康电子智能家居国际交易中心、华强广场酒店、广发银行<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 振华路中<br>
80 、M202、M389、M555<br><br>
B出入口:<br>
公交站名： 华强路口<br>
75、80、M389、M555、高峰专线119<br><br>
C出入口:<br>
公交站名： 航苑大厦<br>
80 、M202、M389、M555<br><br>
E1出入口:<br>
公交站名： 振华路中<br>
M555、80、M202、M389<br><br>
E2出入口:<br>
公交站名： 振华路中<br>
M555、80、M202、M389<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>